import { CreatorProductModule } from '@/api/CreatorProductModuleApi';
import { Attachment, UUID } from './types';
import { Vector2Tuple } from 'three';
import { IconProps } from '@tabler/icons-react';
import { ForwardRefExoticComponent, RefAttributes } from 'react';
import { Project, ProjectContact } from '@/api/ProjectApi';
import { ProductModule } from '@/api/ProductModuleApi';
import { CreatorLandscapeModule } from '@/api/CreatorLandscapeModuleApi';
import { Preset } from '@/api/PresetApi';
import { AttributeValue } from '@/api/AttributeValueApi';

export interface RoomShape {
	id: UUID;
	name: string;
	Icon: ForwardRefExoticComponent<IconProps & RefAttributes<SVGSVGElement>>;
	vertices: Vector2Tuple[];
}

export interface CreatorMeasurement {
	id: UUID;
	name: string;
}

export type PlaygroundTexture = {
	id: UUID;
	image: string;
	name: string;
};

export enum CameraType {
	PERSPECTIVE = 'perspective',
	ORTHOGRAPHIC = 'orthographic',
}

export enum RoomDragType {
	WALL = 'wall',
	ROOM = 'room',
}

export enum CreatorStep {
	SHAPES,
	MODULES,
	CONTACT,
}

export interface CreatorCustomBackground {
	attachment: Attachment | null;
	dimensions: Vector2Tuple;
	rotation: number;
}

export enum HistoryAction {
	UNDO = 'undo',
	REDO = 'redo',
}

export interface CreatorColoringOptions {
	selectedAttributeValue: AttributeValue | null;
	popoverOpened: boolean;
}

export interface CreatorOptions {
	coloringOptions: CreatorColoringOptions;
	isPresetMode: boolean;
	isPreviewMode: boolean;
	selectedShape: UUID | 'custom' | null;
	roomHeight: number;
	currentStep: CreatorStep;
	isLoading: boolean;
	isDrawing: boolean;
	activeCamera: CameraType;
	roomDragType: RoomDragType;
	wallsVisibility: boolean;
	instructionModalOpened: boolean;
	infoProductModule: null | ProductModule;
	productModulesDrawerOpened: boolean;
	landscapeModulesDrawerOpened: boolean;
	successDrawerOpened: boolean;
	roomSurfaceArea: number;
	largestAvailableRectangle: Preset['largestAvailableRectangle'];
	customBackground: CreatorCustomBackground;
	productModuleContextMenuData: {
		moduleLevel: number;
		creatorProductModuleRefId: UUID | null;
		position: Vector2Tuple;
	};
	isMeasuring: boolean;
	creatorMeasurements: CreatorMeasurement[];
	historyLength: number;
	currentHistoryIndex: number;
}

export interface CreatorRendererOptions {
	loading: boolean;
	zoomLevel: number;
	distance: number;
	currentLevel: number;
	levelsQuantity: number;
}

export interface CreatorState {
	creatorProductModules: CreatorProductModule[];
	creatorLandscapeModules: CreatorLandscapeModule[];
	creatorProductModulesByRefId: Record<UUID, CreatorProductModule>;
	creatorLandscapeModulesByRefId: Record<UUID, CreatorLandscapeModule>;
	contact: ProjectContact;
	renderer: CreatorRendererOptions;
	options: CreatorOptions;
	project: Project | null;
	name: string;
}
